/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { ValuesOf } from '@tmapy/beetlejuice-utils';

/**
 * ```yaml
 * type: string
 * description: |-
 *   * `GEODETIC_SURVEYING` - GeodeticSurveying
 *   * `LASER_SCANNING` - Laser scanning
 *   * `PHOTOGRAMMETRY` - Photogrammetry
 * ```
 */
export const DataOriginEnum = {
  GEODETIC_SURVEYING: 'GEODETIC_SURVEYING',
  LASER_SCANNING: 'LASER_SCANNING',
  PHOTOGRAMMETRY: 'PHOTOGRAMMETRY',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type DataOriginEnum = ValuesOf<typeof DataOriginEnum>;

export type DataOriginEnumRequest = DataOriginEnum;
export type DataOriginEnumResponse = DataOriginEnum;
